/**
 * TableData is a renderer-agnostic representation of a tabular display.
 *
 * Shape:
 *   {
 *     columns: [{ name: string, units?: string }, ...],
 *     rows: [
 *       [{ value: string|number, units?: string, isBold?: boolean }, ...],
 *       ...
 *     ],
 *     showHeader?: boolean,  // default true; set false for label/value tables
 *   }
 *
 * Component classes (WallType, WindowType, DoorType, SkylightType) expose
 * getComponentTableData() and getConstructionDetailsData() that return this
 * shape, and the Excel/PDF/Vue renderers each consume it.
 */

export function formatColumnHeader(col) {
  return col.units ? `${col.name} (${col.units})` : col.name;
}

export function formatCellValue(cell) {
  if (cell.units) return `${cell.value} ${cell.units}`;
  return cell.value;
}

/**
 * Combine an array of single-row TableData (one per component instance) into
 * a single TableData with shared columns and concatenated rows.
 * Returns null if the input is empty.
 */
export function combineTableData(tableDataList) {
  if (tableDataList.length === 0) return null;
  return {
    columns: tableDataList[0].columns,
    rows: tableDataList.flatMap(td => td.rows),
    showHeader: tableDataList[0].showHeader,
  };
}
